import { useFilterCondConf } from '@op/hooks/useFilterCondConf';
import useLanguage from '@op/hooks/useLanguage';
import { DBO_U } from '@op/utils/format';
import { useEffect, useMemo, useRef, useState } from 'react';
import { getLocale } from 'umi';

export default function useReportLanguage({
  gameInfo,
  kind,
  setLanguage,
  type,
}: {
  gameInfo: any;
  kind?: number;
  type?: number;
  setLanguage: any;
}) {
  const { formatMessage } = useLanguage();
  const [oriOptions, setOriOptions] = useState<
    { textCn: string; textEn: string; value: string }[] | null
  >(null);
  const { report_gpt_config, loading } = useFilterCondConf({
    gameInfo,
    requestList: [
      {
        key: 'report_gpt_config',
        defaultValue: {},
      },
    ],
    needRender: !!kind,
  });

  useEffect(() => {
    if(oriOptions) return;

    if (!kind || !type) {
      setOriOptions([
        { value: 'zh', textCn: '简体中文', textEn: 'Simplified Chinese' },
        { value: 'en', textCn: '英文', textEn: 'English' },
      ]);
      return;
    }
    const { language } = report_gpt_config;
    if (!language) {
      setOriOptions(null);
      return;
    }
    const list = language?.[kind]?.[type] || [];

    const options = list.map((item: any) => {
      const [value, textEn, textCn] = item || [];
      return { textEn, textCn, value };
    });
    setOriOptions(options);
  }, [kind, report_gpt_config, type]);

 
  const options = useMemo(() => {
    if (!oriOptions) return null;

    const isEn = getLocale() === 'en-US';

    return oriOptions.map(item => {
      return {
        text: isEn ? item.textEn : item.textCn,
        value: item.value,
      };
    });
  }, [formatMessage, oriOptions]);

  const isFirst = useRef(true);

  useEffect(() => {
    if (!options) return;
    setLanguage((oriValue: string) => {
      const data = DBO_U.query(location.search);
      const defaultLanguage = data.get('language');
      let item = null;
      // 如果首次进去，就进这里，判断链接参数
      if (isFirst.current && defaultLanguage) {
        isFirst.current = false;
        item = options.find(item => item.value === defaultLanguage);
      }

      // 发现链接参数没有，就判断当前语言
      if (!item) {
        const local = getLocale() === 'en-US' ? 'en' : 'zh';
        item = options.find(item => item.value === local);
      }

      // 如果还是没有，就取原始数据
      if (!item) {
        item = options.find(item => item.value === oriValue);
      }

      // 如果还是没有，就取第一个
      if (!item) {
        [item] = options;
      }
 
      return item?.value;
    });
  }, [options]);

  return { options, loading };
}
